import { render, staticRenderFns } from "./PortfolioTableRow.vue?vue&type=template&id=c0f5684c&scoped=true&"
import script from "./PortfolioTableRow.vue?vue&type=script&lang=ts&"
export * from "./PortfolioTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./PortfolioTableRow.vue?vue&type=style&index=0&id=c0f5684c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f5684c",
  null
  
)

export default component.exports